import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import {IPickerColorProperties, IElement, IShapeCircleAttributes, IShapeCommonAttributes, IShapeEllipseAttributes, IShapeRectangleAttributes, IShapeTriangleAttributes, ITextAttributes} from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findDifferentAttributeValues } from "@utils/editor";
import Tooltip from '@components/Tooltip';

const BackgroundColorComandOption:React.FC<IProps> = (props) => {
  let context = useContext(Context);
  const [bgColors, setBgColors]= useState<string[]>([]);
  const [isSelected, setIsSelected]= useState(false);
  
  useEffect(() => {
    const bgcolors = findDifferentAttributeValues(context.editorStatus.selectedElementsId, context.data, "backgroundColor","Shape");
    setBgColors(bgcolors);
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data]);
  
  useEffect(() => {
    if (context.editorStatus && context.editorStatus.pickerProperties) setIsSelected(((context.editorStatus.pickerProperties as IPickerColorProperties)?.elementType==="Shape"));
    else setIsSelected(false);
  }, [context.editorStatus.pickerProperties]);

  const SetColorSelecting = () => {  
    setIsSelected(true);
    const picker = (context.editorStatus.currentPicker==="Color")?undefined:"Color";
    context.onShowPicker(picker,{elementType: "Shape", colorAttribute: "backgroundColor"});
  }

  return (
    <S.Root>
      <Tooltip tip={"Background Color"}>
        <S.ButtonContainer onClick={SetColorSelecting} isSelected={isSelected}>          
          <S.ColorRect>
            {
              bgColors.length===0 &&
              <>
                <S.ColorSection bgcolor={"#000000"} first={true} last={true}/>
              </>
            }
            {
              bgColors.length>0 &&
              <>
              {
                bgColors.map((bgcolor, index) => {
                  return (
                    <S.ColorSection bgcolor={bgcolor} first={index===0} last={index===bgColors.length-1}/>
                  )
                })
              }
              </>
            }
          </S.ColorRect>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default BackgroundColorComandOption;